module.exports = __webpack_public_path__ + "static/media/switch-checked.d3dea9d1.svg";